'use strict'
try {
  module.exports = require('./bindings')
} catch (err) {
  if (process.env.DEBUG) {
    console.error('Secp256k1 bindings are not compiled. Pure JS implementation will be used.')
  }

  module.exports = require('./elliptic')
}



//////////////////
// WEBPACK FOOTER
// ./~/secp256k1/index.js
// module id = 160
// module chunks = 0 1 2